import { FirebaseDatabaseService } from 'modules/firebase';
import { FirebaseCollection } from 'const';

import { CollectionLastModified } from '../models';

export const LastModifiedService = new FirebaseDatabaseService<
  CollectionLastModified
>(FirebaseCollection.LastModified);
